import { PwaWorkspaceSettings } from './types';

export const WorkSpace2PwaSettings: PwaWorkspaceSettings = {
  workspaceId: 'workspace-2',
  appName: 'CoinNova',
  appSlug: 'coin-nova-pwa',
  apiUrl: 'https://api.casinogames-fun.com',
  branding: {
    logo: '/icons/icon-192.png',
    favicon: '/icons/icon-192.png',
    primaryColor: '#7C3AED',
  },
  web: {
    title: 'CoinNova',
    shortName: 'CoinNova',
    description: 'Multi-tenant white-label mobile gaming platform PWA for CoinNova',
    themeColor: '#080B16',
    backgroundColor: '#080B16',
  },
  featureFlags: {
    enableReferrals: true,
    enableSupportChat: true,
    enablePromotions: true,
  },
};

export default WorkSpace2PwaSettings;
